export default __webpack_public_path__ + "static/media/disabled.bcf053c2.svg";